/**
 * Google GA43 tracking functions: Not used on this site
 * Keep for reference (and to avoid errors)
 * 
 */

let ga4_uid, ga5_uid;

async function google_initialise() {

	return; 
	
  setGoogleTracker();
	setAFTracker();

}


function google_send_search(){

	return; 

}


function google_send_detail(){

	return; 

 

}


function google_send_book(res_id: string){

	return; 


}

function setGoogleTracker(){

	return; 


}

function setAFTracker(){

	return; 


}


export { google_initialise, google_send_search, google_send_detail, google_send_book, ga4_uid, ga5_uid }
